import { useCurrentColorPalette } from '@shared-ui/theme/context'
import type { NamedStyles } from '@shared-ui/theme/named-styles'
import { theme } from '@shared-ui/theme/tokens'
import type { Theme, ThemeParams } from '@shared-ui/theme/types'
import { getWebSafeArea, subscribeWebSafeArea } from '@shared-ui/theme/web-safe-area'
import { useMemo, useSyncExternalStore } from 'react'

export function useAppTheme(): Theme {
  const palette = useCurrentColorPalette()
  const key = palette === 'dark' ? 'dark' : 'default'
  return (theme[key] || theme.default) as Theme
}

export function createStyleSheet<T extends NamedStyles<T>>(
  styles: T | ((theme: Theme, params: ThemeParams) => T),
): () => T {
  return () => {
    const localTheme = useAppTheme()
    const palette = useCurrentColorPalette()
    const width = typeof window !== 'undefined' ? window.innerWidth : 392
    const height = typeof window !== 'undefined' ? window.innerHeight : 852
    // На обычном web — нули; в Telegram Mini App fullscreen сюда приходит верхний инсет.
    const safe = useSyncExternalStore(subscribeWebSafeArea, getWebSafeArea, getWebSafeArea)

    return useMemo(() => {
      const raw = typeof styles === 'function' ? styles(localTheme as Theme, { palette, safe, width, height }) : styles
      return raw
    }, [localTheme, palette, safe, width, height])
  }
}

export { theme } from '@shared-ui/theme/tokens'
